/* eslint-disable max-lines-per-function */
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import {makeStyles, styled} from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import DownloadIcon from '@material-ui/icons/GetApp';
import React from 'react';
import locale from '../locale/Localization';
import {URL_MANUAL_DE, URL_MANUAL_FR} from '../utils/constants';

const useStyles = makeStyles(() => ({
  root: {flexGrow: 1},
  headline: {paddingTop: '3%', paddingBottom: '1%', color: 'white'},
  button: {marginRight: '1em'}
}));

const Item = styled(Paper)(({theme, padding, elevation, textalign}) => ({
  ...theme.typography.body2,
  padding: theme.spacing(padding),
  elevation: elevation,
  textAlign: textalign
}));

/**
 * The news information view.
 *
 * @return {string} - The component contents to render.
 */
export default function News() {
  const classes = useStyles();

  const handleDownload = (url) => {
    window.open(url);
  };

  const getUrlByLang = (de, fr) => {
    const lang = locale.getLanguage();
    return lang === 'de' ? de : fr;
  };

  return (
    <div className={classes.root}>
      <Typography variant='h5' gutterBottom className={classes.headline}>
        {locale.newsTitle}
      </Typography>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          {renderSignerNews(locale, handleDownload, getUrlByLang)}
        </Grid>
      </Grid>
    </div>
  );
}

const renderSignerNews = (locale, handleDownload, getUrlByLang) => {
  return (
    <Paper elevation={24}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Item padding={2} elevation={1} textalign='left'>
            <Typography variant='h6' gutterBottom>
              {locale.newsHeadline}
            </Typography>
            <Typography variant='body1' gutterBottom>
              {locale.newsDescription}
            </Typography>
            <Typography variant='body1' gutterBottom>
              {locale.newsDescriptionAdditional}
            </Typography>
          </Item>
        </Grid>
        <Grid item xs>
          <Item padding={1} elevation={0} textalign='right'>
            <ButtonGroup disableElevation variant='outlined' color='primary'>
              <Tooltip
                placement='top'
                title={locale.manualDownloadButtonTooltip}
              >
                <Button
                  startIcon={<DownloadIcon />}
                  onClick={() =>
                    handleDownload(getUrlByLang(URL_MANUAL_DE, URL_MANUAL_FR))
                  }
                >
                  {locale.manualDownloadButton}
                </Button>
              </Tooltip>
            </ButtonGroup>
          </Item>
        </Grid>
      </Grid>
    </Paper>
  );
};
